<template>
  <header v-side-navigation>
    <div
      class="
        relative flex min-h-svh flex-col justify-end overflow-hidden
        lg:mr-container-desktop lg:rounded-br-100
      "
    >
      <!-- LOGO -->
      <NuxtLink
        :to="topLevelEntry.url"
        :aria-label="$t('aria_labels.home')"
        class="absolute left-container top-10 z-30 lg:left-container-desktop md:left-container-lg"
        :class="route.path === topLevelEntry.url ? 'cursor-none' : 'cursor-pointer'"
      >
        <IconLogo class="h-5 text-white sm:h-7" />
      </NuxtLink>

      <div
        class="
          absolute inset-0
          after:absolute after:inset-0 after:z-10 after:bg-gradient-to-b after:from-[rgba(11,21,44,0.2)]
          after:via-[rgba(11,21,44,0.2)] after:to-[rgba(11,21,44,0.3)]
        "
      >
        <!-- VIDEO -->
        <VideoPlayer
          v-if="data.video_url"
          is-background-video
          :video-url="data.video_url"
          :cover-image="data.image"
        />

        <!-- IMAGE -->
        <AppImage
          v-else-if="data.image"
          class="size-full object-cover"
          :src="data.image"
          :alt="useMapAltText(data.image)"
          loading="eager"
        />
      </div>

      <Container
        v-animate-children-in-from-bottom
        class="relative z-20 mt-auto py-16 sm:py-container-desktop"
      >
        <!-- TITLE -->
        <h1
          v-if="data.heading"

          class="text-white typo-heading-2xl max-lg:text-center md:typo-display-2xl"
          v-html="data.heading"
        />

        <!-- SCROLLY -->
        <Scrolly class="z-20 mx-auto mt-12 block w-14 lg:mt-5 sm:w-20" />
      </Container>
    </div>
  </header>
</template>

<script lang="ts" setup>
const props = defineProps({
  data: {
    type: Object,
    required: true,
  },
})
const route = useRoute()

// Since the collection allows only one level deep, use parent if it exists, otherwise use entry
const topLevelEntry = computed(() => props.data?.parent || props.data)
</script>
